var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowShareIcon = function SvgArrowShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-share-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.333 0H39a1.667 1.667 0 0 1 1.666 1.667v16.666a1.667 1.667 0 0 1-2.846 1.18l-5.974-5.976-8.823 8.82a3.334 3.334 0 1 1-4.713-4.714l8.82-8.823-5.977-5.973A1.666 1.666 0 0 1 22.333 0m12.643 27.643A3.333 3.333 0 0 1 40.666 30v3.333A6.667 6.667 0 0 1 34 40H7.333a6.667 6.667 0 0 1-6.666-6.667V6.667A6.667 6.667 0 0 1 7.333 0h3.334a3.333 3.333 0 1 1 0 6.667H7.333v26.666H34V30c0-.884.351-1.732.976-2.357",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-share-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h40v40h-40z"
  })))));
};
export default SvgArrowShareIcon;